export function getSharedCookieDomain(): string | undefined {
  if (process.env.NODE_ENV !== 'production') {
    return undefined
  }

  const {hostname} = window.location

  if (hostname.endsWith('.appbrain.com.br')) {
    return '.appbrain.com.br'
  }

  if (hostname.endsWith('.appbrain.com')) {
    return '.appbrain.com'
  }

  return undefined
}
